var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDropdownDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.115,0,9,7.417,15.885,0,18,2.283,9,12,0,2.283Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDropdownDown);
export default __webpack_public_path__ + "static/media/icon-arrow-dropdown-down.be2d9afe5f47eed6b502dcf1e3bb92e4.svg";
export { ForwardRef as ReactComponent };